import { useGetGuestsiteFaqQuery } from './FaqList.graphql.generated';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { useIsCurrentPageSsrFetchEnabled } from '@apps/guest/shared/hooks/useIsCurrentPageSsrFetchEnabled';
import { isInIframe } from '@shared/utils/isInIframe';

export const useFetchFaqListData = (eventHandle: string, skip?: boolean) => {
  const { isAdmin } = useEventUserRole();
  const isPreviewing = isInIframe();
  const isSsrEnabled = useIsCurrentPageSsrFetchEnabled(eventHandle, 'faq');

  const { data, loading } = useGetGuestsiteFaqQuery({
    variables: { eventHandle, isAdminDashboard: isPreviewing && isAdmin },
    batchMode: 'fast',
    fetchPolicy: 'cache-and-network',
    ssr: isSsrEnabled,
    skip,
  });

  return { data, loading };
};
